<template>
  <h4>Баланс: <strong>{{ formattedBalance }}</strong></h4>
</template>

<script>
  import utils from '../../../../utils';

  export default {
    props: ['balance'],
    name: "PlayerBalanceLabel",
    computed: {
      formattedBalance() {
        const { balance } = this;
        if (Number.isNaN(balance)) {
          return 0;
        }
        return utils.convertSystemToCurrency(balance);
      }
    }
  }
</script>

<style scoped>
  h4 {
    font-size: 12px;
    color: #666;
    font-family: Verdana,sans-serif;
    font-weight: normal;
  }

  strong {
    color: #66add6;
  }
</style>
